var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 656,
    viewBox: "0 0 2 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_86)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 335.1V354H0V335.1H2ZM2 368.6V387.5H0V368.6H2ZM2 402.1V421H0V402.1H2ZM2 435.7V454.6H0V435.7H2ZM2 469.2V488.1H0V469.2H2ZM2 502.8V521.7H0V502.8H2ZM2 536.3V555.2H0V536.3H2ZM2 569.9V588.8H0V569.9H2ZM2 603.4V622.3H0V603.4H2ZM2 637V646.5V656H0V637H2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 18.9H0V0H2V18.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 52.5001H0V33.6001H2V52.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 86.0001H0V67.1001H2V86.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 119.6H0V100.7H2V119.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 153.1H0V134.2H2V153.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 186.7H0V167.8H2V186.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 220.2H0V201.3H2V220.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 253.8H0V234.9H2V253.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 287.3H0V268.4H2V287.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 320.8H0V301.9H2V311.4V320.8Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 655.9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadLine);
export default __webpack_public_path__ + "static/media/road-line.baae09ab9c23094a5848c59b4b28e389.svg";
export { ForwardRef as ReactComponent };